import Customer from './Customer';
import CustomerSettings from './CustomerSettings';
import Media from './Media';
import Clip from './Clip';
import UserSettings from './UserSettings';

export const ViPropTypes = {
  Customer,
  CustomerSettings,
  Media,
  Clip,
  UserSettings
};

export default ViPropTypes;
